// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_RSV_standalone_rsv_min_js"], () => (__webpack_require__("./pages/user-agreement.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
